import React from 'react'
import Wizard from 'src/Components/Wizard'

import Steps from './Steps'

const CMASection = ({ onStepChange, close, initialStep, avm, previousREA }) => (
  <Wizard provider initialStep={initialStep} onStepChange={onStepChange}>
    <Wizard step='start'>
      <Steps.Start close={close} previousREA={previousREA} />
    </Wizard>
    <Wizard step='estimateCorrectness'>
      <Steps.Correctness avm={avm} />
    </Wizard>
    <Wizard step='improvements'>
      <Steps.Improvements />
    </Wizard>
    <Wizard step='improvementsDescription'>
      <Steps.ImprovementsDescription />
    </Wizard>
    <Wizard step='homeFacts'>
      <Steps.HomeFacts />
    </Wizard>
    <Wizard step='complete'>
      <Steps.Complete close={close} />
    </Wizard>
  </Wizard>
)

export default CMASection
